import { UIController } from "./ui.controller";

const isPage = slug => document.body.classList.contains(slug);

export const NavController = {
  init() {
    return new Promise((resolve, reject) => {
      try {
        this.initMobileMenuToggle();
        this.initMobileSubMenus();
        if (isPage('home')) {
          this.initMeasurementCheckers();
        } else {
          this.initStickyHeader();
        }
        resolve();
      } catch (error) {
        reject(error);
      }
    })
  },
  
  initMeasurementCheckers() {
    const handleWindowLoad = () => {
      this.initStickyHeaderHome();
    }
    const handleWindowResize = () => {
      this.initStickyHeaderHome();
    }
    window.addEventListener('load', handleWindowLoad);
    window.addEventListener('resize', handleWindowResize);
  },
  
  initStickyHeaderHome() {
    const windowHeight = window.innerHeight;
    const navEl = document.getElementById('site-nav');
    const navHeight = navEl ? navEl.clientHeight : 0;

    const handleScroll = () => {
      const scrollY = window.scrollY;
      if(scrollY > ((windowHeight/2) - (navHeight))) {
        document.documentElement.classList.add('scrolled');
      } else {
        document.documentElement.classList.remove('scrolled');
      }
    };
    const handler = handleScroll;
    window.addEventListener('scroll', handler);
    handler();
  },

  initStickyHeader() {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      if(scrollY > 0) {
        document.documentElement.classList.add('scrolled');
      } else {
        document.documentElement.classList.remove('scrolled');
      }
    };
    const handler = handleScroll;
    window.addEventListener('scroll', handler);
    handler();
  },

  toggleMobileMenu: () => {
    const html = document.documentElement
    const menuIsOpen = html.classList.contains('menu-open');
    if(menuIsOpen) {
      html.classList.remove('menu-open');
    } else {
      html.classList.add('menu-open');
      UIController.recordNavBarHeight();
    }
  },

  initMobileMenuToggle() {
    const toggle = document.querySelector('.nav__hamburger');
    if (!toggle) return; 
    toggle.addEventListener('click', this.toggleMobileMenu);
  },

  initMobileSubMenus() {
    this.initMobileMenuTriggers();
  },

  initMobileMenuTriggers() {
    const els = document.querySelectorAll('.menu-item-has-children > a');
  
    const toggleMobileMenu = event => {
      event.preventDefault(); 
      const { target } = event;
      const { parentNode } = target;
      if (parentNode.classList.contains('open')) {
        parentNode.classList.remove('open');
      } else {
        parentNode.classList.add('open');
      }      
    }
    
    Array.from(els).forEach(el => {
      el.addEventListener('click', toggleMobileMenu);
      document.addEventListener('click', event => {
        const isClickedInside = el.contains(event.target);
        if(!isClickedInside) {
          el.parentElement.classList.remove('open');
        }
      })
    });    
  },
}